import { createService } from "~/hocs/crud";
import * as model from "./model";

const getOrgLevelProductGuid = (record) => {
    return {
        productOrgLevelGuid: record.productOrgLevelGuid,
    };
};

// Service
export const service = createService({
    _defaultLabels: {
        [model.PROPS_CAN_DELETE]: {
            visible: false,
            label: "canDelete",
            gridCol: 5,
            className: "col-shift-15",
        },
        [model.PROPS_PRODUCT_NAMES]: {
            label: "productsHeader",
            gridCol: 40,
        },
        [model.PROPS_ORG_LEVEL_NAMES]: {
            label: "orgLevelList",
            gridCol: 40,
        },
        [model.PROPS_MODIFIED_DATE]: { label: "lastModifiedDate" },
    },
    getGuid: getOrgLevelProductGuid,
    guid: "productOrgLevelGuid",
    id: "orgLevelProducts",
    recordName: "productOrgLevelGuid",
    defaultSort: {
        FieldName: "ProductNames",
        Sort: {
            Direction: "ASC",
            Order: 0,
        },
    },
});
